import { ConvexError } from "convex/values";
import { create } from "zustand";

interface CreditExhaustedModalState {
  isOpen: boolean;
  operation?: string;
  open: (operation?: string) => void;
  close: () => void;
}

export const useCreditExhaustedModal = create<CreditExhaustedModalState>(
  (set) => ({
    isOpen: false,
    operation: undefined,
    open: (operation) => set({ isOpen: true, operation }),
    close: () => set({ isOpen: false, operation: undefined }),
  }),
);

/**
 * Check if an error is a CREDIT_EXHAUSTED ConvexError and open the modal if so.
 * Returns true if the error was handled (credit exhausted), false otherwise.
 */
export function handleCreditExhaustedError(error: unknown): boolean {
  if (
    error instanceof ConvexError &&
    typeof error.data === "object" &&
    error.data !== null &&
    "code" in error.data &&
    error.data.code === "CREDIT_EXHAUSTED"
  ) {
    useCreditExhaustedModal.getState().open();
    return true;
  }
  return false;
}
